'use strict';
angular.module('schoolLinqApp').directive('localUseFieldsDataEntry', localUseFieldDataEntryController);

function localUseFieldDataEntryController() {
	var controller = [
		'$scope',
		'$q',
		'localUseService',
		function (scope, $q, localUseService) {
			scope.loadLocalUse = function () {
				scope.fields = [];
				scope.groups = [];
				scope.dirty = false;
				scope.errors = [];

				localUseService.getEntityData(scope.entityType, scope.entityId, scope.groupFilter).subscribe((response) => {
					if (response.isValid) {
						scope.fields = response.fields;
						// update any null group names to 'Misc.'
						_.forEach(scope.fields, function (field) {
							if (!field.GroupName) field.GroupName = 'Misc.';
						});
						scope.fieldsBackup = angular.copy(scope.fields);
						scope.groups = scope.getGroups();
					} else {
						scope.errors.push(response.error);
					}

					if (scope.mustReload === true) {
						scope.mustReload = false;
						scope.afterSave();
					}
				});
			};

			scope.getGroups = function () {
				var groupNames = _.uniq(
					_.map(scope.fields, function (field) {
						return field.GroupName;
					})
				);

				var groups = [];
				_.forEach(groupNames, function (groupName) {
					var groupFields = scope.getGroupFields(groupName);
					groups.push({
						groupName: groupName,
						groupFields: groupFields,
						updatingName: false,
					});
				});

				return _.sortBy(groups, function (group) {
					return group.groupName.toLowerCase();
				});
			};

			scope.getGroupFields = function (groupName) {
				var groupFields = _.sortBy(
					_.filter(scope.fields, function (field) {
						return field.GroupName === groupName;
					}),
					'Priority'
				);
				return groupFields;
			};

			scope.isDirty = function () {
				scope.dirty = _.some(scope.fields, function (field) {
					return field.IsDirty;
				});
				return scope.dirty;
			};

			scope.save = function () {
				scope.errors = [];
				var promises = [];

				_.forEach(scope.fields, function (field) {
					if (field.IsDirty === true) {
						promises.push(
							new Promise((resolve, reject) => {
								localUseService.postEntityData(field).subscribe(
									(response) => {
										if (response.isValid) {
											field.LocalUseFieldDataId = response.field.LocalUseFieldDataId;
											field.IsDirty = false;
										} else {
											scope.errors.push(field.FieldName + ' error: ' + response.error);
										}
										resolve();
									},
									(error) => {
										scope.errors = error;
										reject();
									}
								);
							})
						);
					}
				});

				if (promises.length) {
					$q.all(promises).then(function () {
						if (scope.errors.length === 0) {
							scope.fieldsBackup = angular.copy(scope.fields);
							scope.groups = scope.getGroups();
							scope.afterSave();
						} else scope.mustReload = true;
					});
				}
			};

			scope.cancelChanges = function () {
				scope.fields = angular.copy(scope.fieldsBackup);
				scope.groups = scope.getGroups();
				scope.errors = [];
				scope.afterCancel();
			};
		},
	];

	return {
		restrict: 'E',
		scope: {
			entityType: '@', // type of entity
			entityId: '=', // integer Id of the entity
			groupFilter: '@', // Ability to filter for certain groups
			okToLoad: '=', // flag to enable/disable loading of data
			readonly: '=', // flag indicating read-only status
			dirty: '=', // let's consumer know if the directive has unsaved changes
			doCancel: '=', // allows consumer to trigger the directive's cancelChanges() function
			afterSave: '&', // reference to function to run after successful save operation
			afterCancel: '&', // reference to function to run after cancel operation
		},
		replace: true,
		template: require('@ajs/templates/localUseFieldsDataEntry.html'),
		controller: controller,
		link: function (scope, element, attrs) {
			scope.$watch('entityId', function (value) {
				if (value && scope.okToLoad === true) scope.loadLocalUse();
			});

			scope.$watch('okToLoad', function (value) {
				if (value === true && scope.entityId) scope.loadLocalUse();
			});

			scope.$watch('doCancel', function (value) {
				if (value === true) {
					scope.doCancel = false;
					scope.cancelChanges();
				}
			});
		},
	};
}
